













import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'ListChubunrui',
  components: {
    CtrlSearchCommonComponents,
  },

  props: {
    mukoUmuFlg: {
      type: Number,
    },
  },

  data: () => ({
    headers: [
      {
        text: 'コード',
        sortable: true,
        value: 'chubunruiCd',
        width: 70,
      },
      {
        text: '名称',
        sortable: true,
        value: 'chubunruiMei',
        width: 289,
      },
    ],
    formatColName: 'chubunruiCd',
  }),
});
